<div class="lds-ring">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>